import { render, staticRenderFns } from "./ClockDashboardItem.vue?vue&type=template&id=114b0d13"
import script from "./ClockDashboardItem.vue?vue&type=script&lang=js"
export * from "./ClockDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('114b0d13')) {
      api.createRecord('114b0d13', component.options)
    } else {
      api.reload('114b0d13', component.options)
    }
    module.hot.accept("./ClockDashboardItem.vue?vue&type=template&id=114b0d13", function () {
      api.rerender('114b0d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/ClockDashboardItem.vue"
export default component.exports